import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'

//Material UI Imports
import Card from '@material-ui/core/Card'
import LockOpenIcon from '@material-ui/icons/LockOpen'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { FormControl } from '@material-ui/core'
import TextField from '@material-ui/core/TextField'
import FormHelperText from '@material-ui/core/FormHelperText'
import { useSnackbar } from 'notistack'


//Redux
import allActions from '../../redux/actions/user'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  card: {
    display: 'flex',
    margin: '16px',
    boxShadow: '0px 3px 11px 0px rgba(0,0,0,0.75)',
    borderRadius: 10,
  },
  button: {
    marginTop: '16px'
  },
  title: {
    marginBottom: '16px'
  },
  link: {
    cursor: 'pointer',
    color: 'white',
    textDecoration: 'underline'
  }
}))

export default function NewPassword(props) {

  const { token } = props.match.params

  const dispatch = useDispatch()
  const history = useHistory()
  const { enqueueSnackbar } = useSnackbar()
  const classes = useStyles()

  const [reset, setReset] = useState({ new: '', confirm: '' })

  const [errorForm, setErrorForm] = useState({ value: false, text: '' })
  const [errorNew, setErrorNew] = useState({ value: false, text: '' })
  const [errorConfirm, setErrorConfirm] = useState({ value: false, text: '' })

  /**
   * Méthode appelée à chaque changement du formulaire
   * @param {*} e : event
   */
  function handleChange(e) {
    let newReset = reset
    newReset[e.target.name] = e.target.value
    setReset(newReset)
  }

  /**
   * Méthode appelée au click du bouton "Reinitaliser"
   */
  async function submit(e) {

    e.preventDefault()

    //Netoyage des erreurs
    setErrorForm({ value: false, text: '' })

    //Vérifie la validité des champs du formulaire
    const valid = checkValid()
    if (!valid) return

    //Appel vers l'API
    const body = { password: reset.new }
    const result = await allActions.fetchPostAPI('api/users/new-password/' + token, body, dispatch)


    //Si la requête n'a pas fonctionnné une erreur est affiché
    if (result.err) {
      setErrorForm({ value: true, text: 'Erreur: ' + result.err })
      return
    }

    const { res, json } = result
    console.log(res)

    //Si le serveur retourne une erreur elle est affiché
    if (!res.ok) {
      setErrorForm({ value: true, text: 'Erreur: ' + json.message })
      return
    }

    //Affichage de l'alerte
    enqueueSnackbar(`Le mot de passe a bien été changé.`, { variant: 'success' })

    //Redirection vers la page d'accueil
    history.push('/')
  }

  /**
   * Vérifie la validité des champs du formulaire
   */
  function checkValid() {

    let isValid = true

    //Vérifie que le nouveau mdp n'est pas vide et qu'il est assez complexe
    const passwordInvalidType = checkPassword(reset.new)
    if (reset.new === '') {
      setErrorNew({ value: true, text: 'Requis' })
      isValid = false
    } else if (!passwordInvalidType.valid) {
      setErrorNew({ value: true, text: passwordInvalidType.msg })
      isValid = false
    } else {
      setErrorNew({ value: false, text: '' })
    }

    //Vérifie que la confirmation du mdp n'est pas vide et qu'elle coresspond au mdp
    if (reset.confirm === '') {
      setErrorConfirm({ value: true, text: 'Requis' })
      isValid = false
    } else if (reset.confirm !== reset.new) {
      setErrorConfirm({ value: true, text: 'Les mots de passe ne corespondent pas' })
      isValid = false
    } else {
      setErrorConfirm({ value: false, text: '' })
    }

    return isValid
  }

  /**
   * Vérifie la complexité du mot de passe
   * @param {*} password 
   * @return {valid, msg}: valid = validité du mdp, msg = message d'erreur si invalide
   */
  function checkPassword(password) {
    const length = /^.{8,}$/
    const lowerCase = /.*[a-z]/
    const upperCase = /.*[A-Z]/
    const digit = /(?=.*\d)/
    const special = /.*[!@#$%^&*.]/

    const sentence = 'Le mot de passe doit contenir au moins '

    if (!password.match(length)) return { valid: false, msg: sentence + '8 caractères' }
    if (!password.match(lowerCase)) return { valid: false, msg: sentence + '1 caractère minuscule' }
    if (!password.match(upperCase)) return { valid: false, msg: sentence + '1 caractère majuscule' }
    if (!password.match(digit)) return { valid: false, msg: sentence + '1 chiffre' }
    if (!password.match(special)) return { valid: false, msg: sentence + '1 caractère speciale' }

    return { valid: true, msg: `` }

  }

  return (
    <div className={classes.root}>
      <Card className={classes.card} >
        <CardContent>
          <Typography variant="h5" component="h2" className={classes.title}>
            Changer de mot de passe
          </Typography>
          <form onSubmit={submit}>
            <FormControl fullWidth={true} error={errorForm.value} >
              <TextField
                error={errorNew.value}
                helperText={errorNew.text}
                margin="dense"
                label="Nouveau mot de passe"
                type="password"
                variant="outlined"
                fullWidth={true}
                name="new"
                onChange={e => handleChange(e)}
              />
              <TextField
                error={errorConfirm.value}
                helperText={errorConfirm.text}
                margin="dense"
                label="Confirmer"
                type="password"
                variant="outlined"
                fullWidth={true}
                name="confirm"
                onChange={e => handleChange(e)}
              />
              <FormHelperText>{errorForm.text}</FormHelperText>

              <Button
                type="submit"
                color="primary"
                fullWidth={true}
                margin="dense"
                className={classes.button}
                startIcon={<LockOpenIcon />}
                variant="contained"
                disableElevation
              >Reinitialiser</Button>
            </FormControl>
          </form>
        </CardContent>
      </Card>
    </div >
  )
}
